import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type SettingsFillProps = IconComponentBaseProps;

export const SettingsFill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: SettingsFillProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_4163_306629"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4163_306629)">
        <path
          d="M9.07687 17.9167C8.7927 17.9167 8.54729 17.8224 8.34062 17.6338C8.13381 17.4453 8.00798 17.2132 7.96312 16.9375L7.75958 15.3781C7.53638 15.3034 7.3075 15.1988 7.07291 15.0642C6.83847 14.9295 6.62881 14.7852 6.44395 14.6315L5 15.2452C4.73819 15.3606 4.47513 15.3718 4.21083 15.2788C3.94638 15.1858 3.74097 15.0171 3.59458 14.7725L2.65541 13.1442C2.50902 12.8996 2.46687 12.6408 2.52895 12.3677C2.5909 12.0948 2.73298 11.8697 2.9552 11.6923L4.20354 10.7548C4.18437 10.6309 4.17076 10.5065 4.1627 10.3815C4.15465 10.2565 4.15062 10.132 4.15062 10.0079C4.15062 9.88945 4.15465 9.76904 4.1627 9.64668C4.17076 9.52432 4.18437 9.3905 4.20354 9.24522L2.9552 8.30772C2.73298 8.13036 2.59222 7.90383 2.53291 7.62814C2.47361 7.35258 2.51715 7.09244 2.66354 6.84772L3.59458 5.24355C3.74097 5.00425 3.94638 4.83682 4.21083 4.74126C4.47513 4.64557 4.73819 4.65543 5 4.77084L6.43583 5.37668C6.6368 5.21751 6.85132 5.07195 7.07937 4.94001C7.30743 4.80807 7.53152 4.70202 7.75166 4.62188L7.96312 3.06251C8.00798 2.78682 8.13381 2.55473 8.34062 2.36626C8.54729 2.17765 8.7927 2.08334 9.07687 2.08334H10.9231C11.2073 2.08334 11.4527 2.17765 11.6594 2.36626C11.8662 2.55473 11.992 2.78682 12.0369 3.06251L12.2404 4.6298C12.4904 4.72063 12.7166 4.82668 12.919 4.94793C13.1215 5.06918 13.3258 5.21209 13.5321 5.37668L15.0081 4.77084C15.2698 4.65543 15.5328 4.64557 15.7973 4.74126C16.0617 4.83682 16.2671 5.00425 16.4133 5.24355L17.3446 6.85584C17.491 7.10043 17.5331 7.35925 17.471 7.6323C17.4091 7.90522 17.267 8.13036 17.0448 8.30772L15.7644 9.26918C15.7942 9.40376 15.8106 9.52959 15.8133 9.64668C15.816 9.76362 15.8173 9.8814 15.8173 10C15.8173 10.1132 15.8146 10.2283 15.8092 10.3454C15.8039 10.4624 15.7847 10.5962 15.7517 10.7469L17.0079 11.6923C17.2301 11.8697 17.3736 12.0948 17.4383 12.3677C17.5029 12.6408 17.462 12.8996 17.3156 13.1442L16.3717 14.7644C16.2254 15.0091 16.0187 15.1779 15.7517 15.2708C15.4846 15.3638 15.2201 15.3525 14.9583 15.2371L13.5321 14.6233C13.3258 14.7879 13.1153 14.9335 12.9006 15.06C12.6859 15.1867 12.4658 15.2901 12.2404 15.3702L12.0369 16.9375C11.992 17.2132 11.8662 17.4453 11.6594 17.6338C11.4527 17.8224 11.2073 17.9167 10.9231 17.9167H9.07687ZM10.0096 12.5C10.7029 12.5 11.2929 12.2567 11.7796 11.77C12.2662 11.2833 12.5096 10.6933 12.5096 10C12.5096 9.30668 12.2662 8.71668 11.7796 8.23001C11.2929 7.74334 10.7029 7.50001 10.0096 7.50001C9.30763 7.50001 8.71548 7.74334 8.23312 8.23001C7.75076 8.71668 7.50958 9.30668 7.50958 10C7.50958 10.6933 7.75076 11.2833 8.23312 11.77C8.71548 12.2567 9.30763 12.5 10.0096 12.5Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
